import type { LocationDescriptor, Path } from 'history';
import urls from 'config/urls';

import { useNavigation } from '../navigation';
import { EMBED_PAGE_PATH } from '../constants';

const urlValues = Object.values(urls);

const useGetEmbeddedLocation = () => {
  const { restrictedPaths } = useNavigation();

  return (location: Path | LocationDescriptor): Path | LocationDescriptor | undefined => {
    const { pathname, search } = typeof location === 'string' ? new URL(location, window.location.origin) : location;

    if (!pathname) return location;

    if (restrictedPaths.includes(pathname)) return undefined;

    if (pathname.includes(EMBED_PAGE_PATH)) {
      throw new Error(`Do not use embedded page route ${EMBED_PAGE_PATH} for navigation directly.`);
    }

    const embeddedPathname = urlValues.find((urlPath) => urlPath === `${EMBED_PAGE_PATH}${pathname}`);

    if (embeddedPathname) {
      if (typeof location === 'string') {
        return `${embeddedPathname}${search}`;
      }

      return {
        ...location,
        pathname: embeddedPathname,
      };
    }

    return undefined;
  };
};

export default useGetEmbeddedLocation;
